import $ from 'jquery'
import DateFilter from '@/components/date-filter';

export default {
    name: 'manage-facture',
    components: {
        DateFilter
    },
    props: [],
    data() {
        return {
            is_loading: true,
            is_empty: false,
            is_load_error: false,

            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },

            fields: [
                { key: 'choix_operation', label: '#' }, 'date', { key: 'societe', label: 'Société' }, 'patient', 
                { key: 'libelle', label: 'Prestation' }, { key: 'pu', label: 'P.U.' }, { key: 'qte', label: 'Qté' },
                { key: 'montant', label: 'Montant' }, { key: 'tot_pac', label: 'Total Prix Assuré' },  
                { key: 'base_assurance', label: 'Total Base Assur.' }, 'taux', 
                { key: 'part_assure', label: 'Part assuré' }, { key: 'part_assureur', label: 'Part assureur' }
            ],

            filter: "",
            perPage: 15,
            print_per_page: -1,
            currentPage: 1,

            seleted_assurance: '',
            selected_societe: '',
            liste_societes: [],

            selected_operations: [],
            all_checked: false,

            can_do_action: false,
            save_loading: false,
            is_confirm: false,
            tot_part_assureur: 0
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                if (this.filter_by_date.slug) {
                    $('.date-filter').modal('show')
                }
            }
        },

        curr_month() {
            this.selected_operations = []
            const data = {
                month: this.curr_month.id,
                one_date: "",
                from_date: "",
                to_date: "",
                assurance_id: this.current_date_filter?.assurance_id,
                souscripteur: this.current_date_filter?.souscripteur,
            }
            this.current_date_filter = data
            this.getOperationRembourseAssurance(this.current_date_filter)
        },

        seleted_assurance() {
            this.selected_operations = []
            this.societe_selected = ''
            this.choixAssurance()

            this.current_date_filter.assurance_id = (this.seleted_assurance != null)?this.seleted_assurance?.id:''
            this.getOperationRembourseAssurance(this.current_date_filter)
        },

        selected_societe() {
            this.selected_operations = []
            this.current_date_filter.societe_id = (this.selected_societe != null)?this.selected_societe?.id:''

            this.getOperationRembourseAssurance(this.current_date_filter)
        },

        selected_operations() {
            if (this.selected_operations.length > 0) {
                this.can_do_action = true
            } else {
                this.can_do_action = false
            }
            this.calcMontantTotal()
        },
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        etat_ouverture_caisse() {
            return this.$store.getters['etat_ouverture_caisse'];
        },

        assurances() {
            return this.$store.getters["assurances"];
        },

        souscripteurs() {
            return this.$store.getters["souscripteurs"];
        },

        operations_rembourse_assurance() {
            return this.$store.getters["operations_rembourse_assurance"];
        },

        rembourse_assurance_length() {
            return this.operations_rembourse_assurance.length
        }
    },

    mounted() {
        if (this.activeRole.nom == 'ROLE_CAISSIERE') {
            this.compte_id = 1 //  Caisse principale
        } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
            this.compte_id = 4 //  Caisse 1 (Infirmier)
        } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
            this.compte_id = 3 //  Comptabilité
        }

        if (this.can_set_pac) {
            this.fields = [
                { key: 'choix_operation', label: '#' }, 'date', { key: 'societe', label: 'Société' }, 'patient', 
                { key: 'libelle', label: 'Prestation' }, { key: 'pu', label: 'P.U.' }, { key: 'qte', label: 'Qté' },
                { key: 'montant', label: 'Montant' }, { key: 'tot_pac', label: 'Total Prix Assuré' },  
                { key: 'base_assurance', label: 'Total Base Assur.' }, 'taux', 
                { key: 'part_assure', label: 'Part assuré' }, { key: 'part_assureur', label: 'Part assureur' }
            ]
        } else {
            this.fields = [
                { key: 'choix_operation', label: '#' }, 'date', { key: 'societe', label: 'Société' }, 'patient', 
                { key: 'libelle', label: 'Prestation' }, { key: 'pu', label: 'P.U.' }, { key: 'qte', label: 'Qté' },
                { key: 'montant', label: 'Montant' },
                { key: 'base_assurance', label: 'Total Base Assur.' }, 'taux', 
                { key: 'part_assure', label: 'Part assuré' }, { key: 'part_assureur', label: 'Part assureur' }
            ]
        }

        this.checkRegisterCashStatus(this.compte_id)        // Function defined in util-mixins.js

        this.curr_month = this.monthOfYear[this.current_date.getMonth()+1]

        this.$store.dispatch("getAssurances")
    },

    methods: {
        getOperationRembourseAssurance(data) {
            this.is_load_error = false
            this.is_loading = true

            this.$store.dispatch("getRemboursementAssurance", data).then(() => {
                if (this.operations_rembourse_assurance.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }

                this.is_loading = false
            }).catch(() => {
                this.is_load_error = true
                this.is_loading = false
            })
        },

        filterByDate(date) {
            this.selected_operations = []
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                assurance_id: this.current_date_filter?.assurance_id,
                souscripteur: this.current_date_filter?.souscripteur,
            }
            this.current_date_filter = data
            this.filter_date = ""

            this.getOperationRembourseAssurance(data)
        },

        choixAssurance() {
            if (this.seleted_assurance == null) {
                this.liste_societes =  []
                return;
            }

            const assurance_id = this.seleted_assurance.id

            if (assurance_id > 0) {
                this.$store.dispatch("getSocieteByAssurance", assurance_id).then(() => {
                    this.liste_societes = this.souscripteurs
                })
            } else {
                this.liste_societes =  []
            }
        },

        checkAll() {
            let is_checked = $('#check-all').is(":checked")

            if (is_checked) {
                this.selected_operations = []

                this.operations_rembourse_assurance.forEach((operation) => {
                    this.selected_operations.push(operation)
                });
                this.all_checked = true
                
            } else {
                this.selected_operations = []
                this.all_checked = false
            }
        },

        onOneChange() {
            document.getElementById("check-all").checked = false;
        },

        /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        generateBill(selector) {
            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.save_loading = false
                return
            }

            if (this.seleted_assurance == null) {
                this.warningToast("Merci de choisir une assurance !")
                return;
            }

            const data = {
                assurance_id: this.seleted_assurance.id,
                user_id: this.userCredentials.user.id,
                operations: this.selected_operations
            }

            this.save_loading = true;
            this.$store.dispatch('generateInsuranceBill', data).then((response) => {
                if (response.success) {
                    this.successToast("Facture générée avec succès")
                    
                    this.is_confirm = false
                    this.$refs.confirm_bill.click();
                    this.$router.push({ path: '/factures/remboursement-assurance' })
                } else {
                    if (response.code == 500) {
                        this.warningToast("Une erreur s'est produite lors de la génération de la facture !")
                    }
                }
                this.save_loading = false
            }).catch(() => {
                this.warningToast("Une erreur s'est produite !")
                this.save_loading = false
            })
        },

        calcMontantTotal() {
            this.tot_part_assureur = 0
            this.selected_operations.forEach(operation => {
                this.tot_part_assureur += parseInt(operation.part_assureur)
            });
        }
    }
}